import { T } from '@fire/i18n/i18n-constants';

export const PREFIX = T?.SearchResult ?? '';
export const MIN_CAMPSITES = 5;
